export const PORTFOLIO = [
  { id: 1, label: "Objekt 01", city: "Wien · 1070", typ: "ALTBAU · 2-Zi", flaeche: 58, kaufpreis: 285000, miete: 1140, nk: 95, kredit: 1080, mwert: 342000, rendite: 4.8, cashflow: -35 },
  { id: 2, label: "Objekt 02", city: "Wien · 1020", typ: "NEUBAU · 3-Zi", flaeche: 82, kaufpreis: 415000, miete: 1680, nk: 130, kredit: 1520, mwert: 468000, rendite: 4.85, cashflow: 30 },
  { id: 3, label: "Objekt 03", city: "Graz · West",  typ: "ALTBAU · 1-Zi", flaeche: 42, kaufpreis: 168000, miete: 720,  nk: 70,  kredit: 640,  mwert: 192000, rendite: 5.14, cashflow: 10 },
  { id: 4, label: "Objekt 04", city: "Wien · 1100", typ: "NEUBAU · 2-Zi", flaeche: 64, kaufpreis: 312000, miete: 1250, nk: 105, kredit: 1180, mwert: 348000, rendite: 4.81, cashflow: -35 },
  { id: 5, label: "Objekt 05", city: "Linz · Zentr", typ: "ALTBAU · 3-Zi", flaeche: 95, kaufpreis: 348000, miete: 1490, nk: 145, kredit: 1310, mwert: 392000, rendite: 5.14, cashflow: 35 },
  { id: 6, label: "Objekt 06", city: "Wien · 1160", typ: "NEUBAU · 2-Zi", flaeche: 56, kaufpreis: 268000, miete: 1090, nk: 88,  kredit: 1020, mwert: 298000, rendite: 4.88, cashflow: -18 },
];

export const TOTALS = (() => {
  const wert  = PORTFOLIO.reduce((s, o) => s + o.mwert, 0);
  const kauf  = PORTFOLIO.reduce((s, o) => s + o.kaufpreis, 0);
  const miete = PORTFOLIO.reduce((s, o) => s + o.miete, 0);
  const cf    = PORTFOLIO.reduce((s, o) => s + o.cashflow, 0);
  return {
    wert, kauf, miete, cf,
    wertstg: wert - kauf,
    wertstgPct: ((wert - kauf) / kauf) * 100,
    rendite: (miete * 12) / kauf * 100,
    units: PORTFOLIO.length,
  };
})();

export const VALUE_SERIES = (() => {
  const out = []; let v = TOTALS.kauf;
  const step = (TOTALS.wert - TOTALS.kauf) / 24;
  for (let i = 0; i <= 24; i++) {
    const noise = Math.sin(i * 0.7) * 8000 + Math.cos(i * 1.3) * 4500;
    out.push(Math.round(v + noise));
    v += step;
  }
  return out;
})();

export const CASHFLOW_SERIES = [
  -120, -95, -60, -40, -25, -10, 5, 15, 8, 22, 35, 28,
  40, 55, 48, 62, 70, 65, 78, 85, 80, 92, 105, 98,
];

export const fmtEur = (n: number, opts: { decimals?: number, sign?: boolean } = {}) => {
  const { decimals = 0, sign = false } = opts;
  const abs = Math.abs(n);
  const s = abs.toLocaleString("de-AT", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  const pre = n < 0 ? "−" : sign && n > 0 ? "+" : "";
  return `${pre}€ ${s}`;
};

export const fmtPct = (n: number, opts: { decimals?: number, sign?: boolean } = {}) => {
  const { decimals = 2, sign = true } = opts;
  const abs = Math.abs(n).toFixed(decimals).replace(".", ",");
  const pre = n < 0 ? "−" : sign && n > 0 ? "+" : "";
  return `${pre}${abs} %`;
};

export const fmtNum = (n: number) => n.toLocaleString("de-AT");
